import { createDecorator } from '../../instantiation/common/instantiation.js';
const IStorageService = ( createDecorator('storageService'));
export { IStorageService };
